module.exports = __webpack_public_path__ + "static/media/t03ru.c7884ef7.pdf";